<template>
  <div class="home">
    <top></top>
    <about></about>
    <characters></characters>
    <guideline></guideline>
    <contact></contact>
  </div>
</template>

<script>
import top from '../components/home/top'
import about from '../components/home/about'
import characters from '../components/home/characters'
import guideline from '../components/home/guideline'
import contact from '../components/home/contact'

export default {
  name: 'Home',
  components: {
    top,
    about,
    characters,
    guideline,
    contact
  }
}
</script>

<style lang="scss">
.test {
  min-height: 100vh;
}
</style>
